import React from 'react';

export type NoteChannel = 'client' | 'subcontractor' | 'internal';

const CHANNEL_STYLES: Record<NoteChannel, string> = {
	client: 'bg-grey-5 text-character-primary',
	subcontractor: 'bg-grey-5 text-character-primary',
	internal: 'bg-teal-1 text-character-primary',
};

const CHANNEL_LABELS: Record<NoteChannel, string> = {
	client: 'Client',
	subcontractor: 'Subcontractor',
	internal: 'Internal',
};

interface NoteChannelTagProps {
	channel: NoteChannel;
	isInternalTech?: boolean;
}

const NoteChannelTag: React.FC<NoteChannelTagProps> = ({ channel, isInternalTech }) => {
	if (isInternalTech && channel === 'client') return null;
	return (
		<span
			className={`footnoteregular inline-flex shrink-0 items-center rounded-[2px] px-2 py-[1px] ${CHANNEL_STYLES[channel]}`}
		>
			{CHANNEL_LABELS[channel]}
		</span>
	);
};

export default NoteChannelTag;
